import React from 'react';
import './committee.css';

const Committee = ({ committeeInfo }) => {
    return (
        <section className="committee-container">
            <div className="heading-container">
                <h4>Committee Members</h4>
            </div>
            
            {committeeInfo.map((item, index) => (
                <article key={index} className="committee-section">
                    {/* Main Committee */}
                    <section className="mb-4">
                        <h2 className="committee-title">{item?.mainCommittee?.committeeName}</h2>
                        <div className="members-list">
                            {item.mainCommittee?.members.map((member, index) => (
                                <div key={index} className="member-info">
                                    <p className="member-name">
                                        <strong>{member?.name}</strong>, {member?.affiliation}
                                    </p>
                                    {/* {member?.email && 
                                        <p className="member-email text-primary small mt-1">
                                            {member?.email}
                                        </p>
                                    } */}
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* Sub Committee */}
                    <section>
                        <h2 className="committee-title">{item?.subCommittee?.subCommitteeName}</h2>
                        <div className="members-list">
                            {item.subCommittee?.subCommitteeMembers.map((member, index) => (
                                <div key={index} className="member-info">
                                    <p className="member-name">
                                        <strong>{member?.name}</strong>, {member?.affiliation}
                                    </p>
                                    {/* {member?.email && 
                                        <p className="member-email text-primary small mt-1">
                                            {member?.email}
                                        </p>
                                    } */}
                                </div>
                            ))}
                        </div>
                    </section>
                </article>
            ))}
        </section>
    );
};

export default Committee;